import Vue from 'vue'

export default Vue.extend({
  name: 'transitionable',

  props: {
    mode: String,
    origin: String,
    transition: String
  }
})
